import {
  NameSpecifiedEntity
} from "../entity";

export class Company extends NameSpecifiedEntity<string> {
  constructor(code: string, name: string) {
    super(code, name);
  }

  clone() {
    return new Company(
      this.id,
      this.name,
    );
  }
}
